import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <h3>Riverside AI</h3>
          </div>
          <div className="footer-links">
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#team">Team</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          <div className="social-links">
            <button 
              className="social-link" 
              onClick={() => window.open('https://linkedin.com', '_blank')}
              aria-label="LinkedIn"
            >
              LinkedIn
            </button>
            <button 
              className="social-link" 
              onClick={() => window.open('https://twitter.com', '_blank')}
              aria-label="Twitter"
            >
              Twitter
            </button>
            <button 
              className="social-link" 
              onClick={() => window.open('https://facebook.com', '_blank')}
              aria-label="Facebook"
            >
              Facebook
            </button>
          </div>
        </div>
        <div className="copyright">
          <p>&copy; {new Date().getFullYear()} Riverside AI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 